import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    id: "acceptance",
    heading: "Acceptance of these terms",
    body: [
      "By accessing or using www.modimarine.com (the \"Website\"), you agree to be bound by these Terms and Conditions and by our Privacy Policy. If you do not agree, please do not use the Website. The Website is operated by Modi Marine, a unit of Modi Auto Group, India.",
    ],
  },
  {
    id: "information",
    heading: "Information on the Website",
    body: [
      "The Website presents yachts, boats and tenders built by the international shipyards Modi Marine represents in India. Specifications, dimensions, performance figures, images, renderings and descriptions are provided by the respective manufacturers and are for general guidance only. They may relate to optional equipment, export versions or earlier model years, and may change without notice.",
      "Nothing on the Website constitutes an offer to sell, a binding quotation or a guarantee of availability. All sales are subject to a separate written agreement and to the manufacturer's current specifications at the time of order.",
    ],
  },
  {
    id: "pricing",
    heading: "Pricing and availability",
    body: [
      "Where prices are shown as \"On Request\" or otherwise indicated, they are indicative only. Final pricing depends on specification, options, exchange rates, shipping, Indian import duties and taxes, registration and delivery location, and will be confirmed in writing before any commitment is made. Build slots and delivery times are subject to shipyard confirmation.",
    ],
  },
  {
    id: "enquiries",
    heading: "Enquiries, sea trials and viewings",
    body: [
      "Submitting an enquiry through the Website does not create any contractual obligation on either party. Sea trials, viewings and private consultations are arranged at Modi Marine's discretion, may be subject to identity verification and availability, and are governed by any additional terms communicated at the time of booking.",
    ],
  },
  {
    id: "intellectual-property",
    heading: "Intellectual property",
    body: [
      "The Modi Marine name, logo and all original content on the Website are the property of Modi Marine or Modi Auto Group. Brand names, logos, photography and films of the yachts belong to their respective manufacturers and are used under licence or with permission. You may view and print pages for personal, non-commercial use only; any other reproduction, distribution or modification requires prior written consent.",
    ],
  },
  {
    id: "acceptable-use",
    heading: "Acceptable use",
    body: [
      "You agree not to:",
      [
        "Use the Website for any unlawful purpose or in a way that could damage, disable or impair it.",
        "Attempt to gain unauthorised access to any part of the Website, its servers or connected systems.",
        "Submit false, misleading or malicious information through our forms.",
        "Scrape, harvest or extract data, images or content from the Website by automated means.",
      ],
    ],
  },
  {
    id: "third-party",
    heading: "Third-party links and services",
    body: [
      "The Website may link to manufacturer websites, social-media platforms, messaging services such as WhatsApp, and other third-party resources. These are provided for convenience; Modi Marine does not control them and accepts no responsibility for their content, privacy practices or availability.",
    ],
  },
  {
    id: "liability",
    heading: "Limitation of liability",
    body: [
      "The Website is provided \"as is\" and \"as available\". To the fullest extent permitted by law, Modi Marine excludes all warranties, express or implied, and shall not be liable for any indirect, incidental or consequential loss arising from your use of, or inability to use, the Website or reliance on any information it contains. Nothing in these terms limits liability that cannot be excluded under Indian law.",
    ],
  },
  {
    id: "governing-law",
    heading: "Governing law and changes",
    body: [
      "These Terms are governed by the laws of India. Any dispute arising from the use of the Website shall be subject to the exclusive jurisdiction of the competent courts of India.",
      "We may revise these Terms at any time by updating this page. Continued use of the Website after changes are posted constitutes acceptance of the revised Terms. Questions about these Terms may be directed to bespoke@modimarine.com.",
    ],
  },
];

export default function TermsPage() {
  return (
    <LegalPage
      testId="terms-page"
      title="Terms &"
      accent="Conditions."
      updated="October 2026"
      intro="These terms govern your use of the Modi Marine website. They are written to be read, not merely accepted — please take a moment with them."
      sections={SECTIONS}
    />
  );
}
